var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routes.length)?_c('div',[_c('transition-group',{attrs:{"name":"routes","tag":"div"}},_vm._l((_vm.routes),function(route){return _c('Route',{key:route.id,attrs:{"route":route}})}),1)],1):_c('Empty')}
var staticRenderFns = []

export { render, staticRenderFns }